const Products = () => import('./Products'),
    Product = () => import('./Product');

export default [{
    name: 'products',
    path: '/admin/products/:page',
    component: Products,
    props: true,
}, {
    name: 'product-create',
    path: '/admin/product/create',
    component: Product,
}, {
    name: 'product-edit',
    path: '/admin/product/:id',
    component: Product,
    props: true,
}];
